import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';

const EventDetailsBox = ({ event }) => {
  return (
    <section className="event-details-box py-4">
      <Container>
        <Row className="justify-content-center">
          <Col md={10} lg={8}>
            <Card className="border-0 shadow event-card">
              <Card.Body className="p-4 bg-warning text-dark">
                <Row>
                  <Col md={7}>
                    <h3 className="fw-bold mb-4">EVENT DETAILS</h3>
                    <ul className="list-unstyled">
                      <li className="mb-3 d-flex align-items-center">
                        <i className="bi bi-calendar-event fs-4 me-3"></i>
                        <div>
                          <strong className="d-block fs-5">DATES:</strong>
                          <span className="fs-4 fw-bold">{event.dates}</span>
                        </div>
                      </li>
                      <li className="mb-3 d-flex align-items-center">
                        <i className="bi bi-geo-alt fs-4 me-3"></i>
                        <div>
                          <strong className="d-block fs-5">LOCATION:</strong>
                          <span className="fs-5">{event.location}</span>
                        </div>
                      </li>
                    </ul>
                  </Col>
                  <Col md={5} className="d-flex align-items-center justify-content-center">
                    <div className="highlight-box bg-dark text-warning p-3 text-center rounded">
                      <h4 className="mb-0 fw-bold">{event.tagline.toUpperCase()}</h4>
                    </div>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default EventDetailsBox;